<nav class="nav-container d-flex flex-column justify-content-between" data-test-id="navigation-panel">
  <div>
    <img priority ngSrc="/assets/herc-logo.svg" class="logo"
         alt="Herc Rentals logo" width="140" height="23">

    <ul class="nav-list" data-test-id="navigation-panel-list">
      @for (item of navItems; track item.route) {
        <ng-container *hasPermissions="item.permissions">
          <li class="nav-item" routerLinkActive="active">
            <a [routerLink]="item.route"><i [class]="item.icon"></i> {{ item.label }}</a>
          </li>
        </ng-container>
      }
      @if (showPermissionOverrides) {
        <li class="nav-item" routerLinkActive="active">
          <a routerLink="/permission-overrides"><i class="pi pi-user-edit"></i> Permission Overrides</a>
        </li>
      }
    </ul>
  </div>
  <div class="nav-bottom">
    <app-user-section></app-user-section>
  </div>
</nav>
